__webpack_require__.p = "/keralaplots/";